import * as React from "react";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { MantineAccordion } from "components/bootstrap";
import { MarkdownPreview } from "components/common/MarkdownEditor";
import { Col, Row } from "common/components/layout-styles";
import StepActionsButton from "security-app/components/SecurityEvents/EventProcedures/plugin/StepList/StepActionsButton";
function StepLabel({ step, order, eventId = void 0 }) {
  const { t } = useTranslation("enterprise_security_events");
  return /* @__PURE__ */ React.createElement(Row, { $align: "flex-start", $gap: "sm", $width: "auto", style: { paddingRight: "0.5rem" } }, /* @__PURE__ */ React.createElement("span", null, order, "."), /* @__PURE__ */ React.createElement(Col, { $gap: "xs" }, /* @__PURE__ */ React.createElement("span", null, step.title || t("step_list_view.step_number", { order })), /* @__PURE__ */ React.createElement(StepActionsButton, { step, eventId })));
}
function StepListView({ steps, eventId = void 0 }) {
  const { t } = useTranslation("enterprise_security_events");
  const items = useMemo(
    () => steps.map((step, index) => ({
      value: step.id,
      label: /* @__PURE__ */ React.createElement(StepLabel, { step, order: index + 1, eventId }),
      content: step.description ? /* @__PURE__ */ React.createElement(MarkdownPreview, { value: step.description, maxHeight: 300, noBackground: true, noBorder: true, noPadding: true, show: true }) : /* @__PURE__ */ React.createElement("i", null, t("step_list_view.no_description"))
    })),
    [eventId, steps, t]
  );
  return /* @__PURE__ */ React.createElement(MantineAccordion, { variant: "separated", chevronPosition: "right", accordionItems: items, defaultValue: null });
}
export default StepListView;
